<template>
    <div class="news-view container pt-7 pt-lg-8 pb-5">
      <div class="row">
        <div class="col d-flex flex-column align-items-center align-items-lg-start">
          <p class="news-date">
            {{ formattedDate }}
          </p>
          <p class="news-title">
            {{ news.title }}
          </p>
          <div class="news-image rounded-3 d-block d-lg-none my-3" :style="{backgroundImage:`url(${news.primaryImage.url})`}"></div>
          <p class="news-content mt-4" v-html="news.content">
          </p>
        </div>
        <div class="col-auto d-none d-lg-block mt-5">
          <div class="news-image rounded-3" :style="{backgroundImage:`url(${news.primaryImage.url})`}"></div>
        </div>
      </div>
      <section class="more-articles d-flex flex-column justify-content-center py-5 ">
        <h2 class="fw-bold text-primary text-center">{{$t('latest-articles')}}</h2>
        <div class="d-flex flex-wrap justify-content-center gap-4 py-5">
          <div
            v-for="oneNews in allNews.filter(v => v.slug !== $route.params.slug).slice(0,4)"
            :key="oneNews.id"
          >
            <NewsCard  :news="oneNews" />
          </div>

        </div>
      </section>
    </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
import NewsCard from '../components/NewsCard.vue'
export default {
  components: {
    NewsCard
  },
  data () {
    return {
    }
  },
  watch: {
  },
  computed: {
    ...mapState({
      allNews: state => state.news.news
    }),
    ...mapGetters({
      getNewsBySlug: 'news/getBySlug'
    }),
    news () {
      return this.getNewsBySlug(this.$route.params.slug)
    },
    formattedDate () {
      return moment(this.news.date).format('YYYY-MM-DD')
    }
  }
}
</script>
<style lang="scss" scoped>
.news-view{
  .news-title{
    font-size: 35px;
    font-weight: 700;
    line-height: 1.4;
    @media(max-width:992px) {
      text-align: center;
      font-size: 28px;
    }
    @media(max-width: 576px) {
      font-size: 23px;
    }
  }

  .news-content{
    font-size: 20px;
    font-weight: 500;
    @media(max-width:992px) {
      text-align: center;
      font-size: 18px;
    }
    @media(max-width: 576px) {
      font-size: 16px;
    }
  }
  .news-date {
    font-weight: 600;
    color: var(--bs-primary);
  }
  .news-image{
    width: 400px;
    max-width: 80vw;
    aspect-ratio: 4 / 3;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
}
</style>
<style lang="scss">
.news-view{
  .news-content{
    *{
      width: 100% !important;
    }
  }
}
</style>
